import React, { useState, useEffect } from 'react';
import { Button, Result, Typography, Divider, Alert, Row, Col, theme } from 'antd';
import {
  CheckCircleFilled,
} from '@ant-design/icons';
import { useNavigate, useParams } from 'react-router-dom';
import { useIntl } from 'react-intl';

const { Title, Text } = Typography;

const getAnimationStyle = (animate: boolean, delay: number = 0) => ({
  transition: `all 1s ease ${delay}ms`,
  opacity: animate ? 1 : 0,
  transform: animate ? 'translateY(0)' : 'translateY(16px)',
});


const PaymentSuccess:React.FC = ()=> {
  const { propcode } = useParams<{ propcode: string }>()
  const [animate, setAnimate] = useState(false);
  const { token } = theme.useToken();
  const navigate = useNavigate();
  const intl = useIntl();
  useEffect(() => {
    setAnimate(true);
  }, []);

  const onBack = ()=>{
    navigate(`/booking/${propcode}`);
  }
  return (
    <div style={{
      minHeight: '80vh',
      background: token.colorBgLayout,
      padding: '16px'
    }}>

      {/* Main Content */}
      <div style={{ maxWidth: '896px', margin: '0 auto' }}>
        <div style={getAnimationStyle(animate)}>
          <Result
            icon={<CheckCircleFilled style={{ fontSize: '96px', color: token.colorSuccess }} />}
            title={<Title level={2} style={{ color: token.colorTextHeading }}>{intl.formatMessage({id: "payment.success.title"})}</Title>}
            subTitle={<span style={{ color: token.colorTextSecondary }}>{intl.formatMessage({id: "payment.success.subtitle"})}</span>}
          />
        </div>
        <div style={{ marginTop: '32px', ...getAnimationStyle(animate, 700) }}>
          <Alert
            title={<Text strong>{intl.formatMessage({id: "payment.success.alert.title"})}</Text>}
            description={
              <ul style={{ listStyleType: 'disc', paddingLeft: '20px' }}>
                <li>{intl.formatMessage({id: "payment.success.alert.line1"})}</li>
                <li>{intl.formatMessage({id: "payment.success.alert.line2"})}</li>
                <li>{intl.formatMessage({id: "payment.success.alert.line3"})}</li>
              </ul>
            }
            type="info"
            showIcon
          />
        </div>
        <Divider/>
        <div style={getAnimationStyle(animate, 500)}>
          <Row gutter={[16, 16]}>
            <Col xs={24}>
              <Button type="primary" size="large" block onClick={onBack}>{intl.formatMessage({id: "label.backToHome"})}</Button>
            </Col>
          </Row>
        </div>
      </div>
    </div>
  );
}

export default PaymentSuccess